const API_BASE_URL = "https://travel.viryawildlifetours.com"; 

export default API_BASE_URL;
